/* eslint-disable @typescript-eslint/no-misused-promises */

import * as Sentry from "@sentry/vue";

const PromiseAny = (promises) => {
  if (Promise.any) {
    return Promise.any(promises);
  } else {
    // polyfill
    return Promise.all(
      [...promises].map((promise) => {
        return new Promise((resolve, reject) =>
          Promise.resolve(promise).then(reject, resolve)
        );
      })
    ).then(
      (errors) => Promise.reject(errors),
      (value) => Promise.resolve(value)
    );
  }
};

class ApiExtensions {
  get settings() {
    return window.$store.getters["settings/allSettings"];
  }
  get alternativeBackends() {
    return this.settings.alternativeBackends;
  }
  get alternativeBackendsTimeout() {
    return this.settings.alternativeBackendsTimeout;
  }

  alternativeRequestsWithoutPriority = (http, method, body) => {
    const alternativeRequests = this.alternativeBackends
      ? this.alternativeBackends
          .split(",")
          .map((x) => x.trim())
          .filter((x) => x && x != location.origin)
          .map((x) => http.post(method, body, { baseURL: x.trim() }))
      : [];

    return alternativeRequests.length
      ? Promise.all([
          PromiseAny(alternativeRequests),
          new Promise((resolve) =>
            setTimeout(resolve, this.alternativeBackendsTimeout)
          ),
        ]).then((responses) => responses[0])
      : Promise.reject();
  };

  alternativeRequestsWithPriority = (http, method, body) => {
    const promiseResponses = [];
    const alternativeBackends = this.alternativeBackends
      .split(",")
      .map((x) => x.trim())
      .filter((x) => x && x != location.origin);
    const alternativeRequests = alternativeBackends
      ? alternativeBackends.map((x) =>
          http.post(method, body, { baseURL: x }).then((response) => {
            promiseResponses.push(response);
            return response;
          })
        )
      : [];

    return alternativeRequests.length
      ? Promise.all([
          PromiseAny(alternativeRequests),
          new Promise((resolve) =>
            setTimeout(resolve, this.alternativeBackendsTimeout)
          ),
        ]).then((responses) => {
          for (let i = 0; i < alternativeBackends.length; i++) {
            const promiseResponseIndex = promiseResponses.findIndex(
              (x) => x.config.baseURL == alternativeBackends[i]
            );
            if (promiseResponseIndex > -1) {
              return promiseResponses[promiseResponseIndex];
            }
          }
          return responses[0];
        })
      : Promise.reject();
  };

  constructor() {}

  postParallel(http, method, body) {
    try {
      const usePriority = true;
      return PromiseAny([
        http.post(method, body),
        usePriority
          ? this.alternativeRequestsWithPriority(http, method, body)
          : this.alternativeRequestsWithoutPriority(http, method, body),
      ]).then((response) => {
        if (response.config.baseURL) {
          showError("Код ошибки: CLIENT_ERROR:ALTERNATIVE_BACKEND_USED");
          console.log(
            `ERROR: "${method}" использовал резервный backend`,
            response.config.baseURL
          );
        }
        return response;
      });
    } catch (error) {
      Sentry.captureException(error);
      return http.post(method, body);
    }
  }
}

export default new ApiExtensions();
